CANDYRACK_DOCUMENT_LISTENER = true;

/// use CR custom variant selector feature
window.CANDYRACK_VARIANT_SELECTOR_FUNCTION = function(btn) {
  // walk up the tree to first product box element from Shogun
  var shgProductBox = btn.closest("div[data-is-product-box]");
  // return Shogun product object matching the UUID from product box
  var shgProduct = __shgProductInits.filter(function(product) {
    return product.uuid === shgProductBox.id;
  })[0];
 
  var productVariantId = shgProduct.productVariantId;
  return productVariantId;
};
